// Stars.js — Estrelas de avaliação (cheias / meia / vazias) no padrão laranja da marca.
// `value` 0–5 (aceita frações p/ meia estrela); `size` em classe Tailwind de fonte.
import React from "react";

const Stars = ({ value = 0, size = "text-base", className = "" }) => {
  const v = Math.max(0, Math.min(5, Number(value) || 0));
  return (
    <span className={"inline-flex items-center gap-0.5 text-insigne-orange " + size + " " + className} aria-label={`${v} de 5 estrelas`}>
      {[0, 1, 2, 3, 4].map((i) => {
        const cheia = v >= i + 1;
        const meia = !cheia && v >= i + 0.5;
        return <i key={i} className={"bi " + (cheia ? "bi-star-fill" : meia ? "bi-star-half" : "bi-star")} />;
      })}
    </span>
  );
};

export default Stars;
